import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ServiceOverview from './pages/ServiceOverview';
import ServiceDetail from './pages/ServiceDetail';
import KongDashboard from './components/KongDashboard';
import './styles/global.css';
import 'antd/dist/reset.css';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/services" replace />} />
        <Route path="/services" element={<ServiceOverview />} />
        <Route path="/services/:id" element={<ServiceDetail />} />
        <Route path="*" element={<KongDashboard />} />
      </Routes>
    </Router>
  );
};

export default App; 